import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { Loading } from "../../../components/Loading/Loading";
import { Calendars } from "../../../components/Calendar/Calendar";
import { useHistory } from "react-router-dom";
import {dataUserSession} from '../../../utilities/dataSession';

//SERVICE
import {genOrderStatusList} from '../../../service/GEN/GenService';

//CSS
import './P111.css'
import { Dropdown } from "primereact/dropdown";
import ValidateService from "../../../components/ValidateService/ValidateService";

export default function P111() {
    const history = useHistory();
    const toast = useRef(null);
    const [loading, setLoading] = useState(false);
    const [errData, setErrData] = useState(null);

    const [data, setData] = useState({
        "contractNo": "",
        "orderDateBegin": "",
        "orderDateEnd": "",
        "orderStatus": "",
        "searchWord": "",
        "supervisor": "",
      });


    const [genSrh, setGenSrh] = useState({"userId":""});
    const [orderStatusList, setOrderStatusList] = useState([]);

    const onInputTextChange = (e, key) => {
        const val = (e.target && e.target.value) || "";
        setData({
            ...data,
            [`${key}`]: val,
        });
    };

    const onSearch = () =>{
        // console.log('dataSrh ',data)
        history.push({
            pathname: "/107",
            state: { dataSrh: data }
        });

    }

    useEffect(() => {
        if(dataUserSession()){
            if(history.location.state && history.location.state.dataSrh){
                setData({
                    ...history.location.state.dataSrh,
                    orderDateBegin : (history.location.state.dataSrh.orderDateBegin !== '')?history.location.state.dataSrh.orderDateBegin:"",
                    orderDateEnd : (history.location.state.dataSrh.orderDateEnd !== '')?history.location.state.dataSrh.orderDateEnd:"",
                })
            }

            setGenSrh({
                "userId": dataUserSession().userId
            })

        }else{
            history.push('/login')
        }

    }, []);

    useEffect(() => {
        onGenOrderStatusList();
    }, [genSrh]);

    const onGenOrderStatusList = () => {
        setLoading(true);
        genOrderStatusList(genSrh)
            .then(res => {
                setLoading(false);
                if (res != undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach(element => {
                        temp.push({
                            ...element,
                            index: index
                        })
                        index++;
                    });
                    setOrderStatusList(temp);
                }else {
                    showMessages('error', `เกิดข้อผิดพลาด Status Code: ${res.status}`, `${res.message}`);
                }
            }, function (err) {
                setLoading(false);
                setErrData(err)
            });
    }

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    return (
        <>
            <Loading loading={loading} />
            <ValidateService err ={errData} setErr ={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">
                    <div className="card">
                        {/* <h2 className="p-m-0">ค้นหางานสั่งการเฉพาะอย่าง</h2>
                        <hr/> */}
                        <div className="p-grid  p-fluid">
                            <div className="p-col-12 p-md-2"></div>
                            <div className="p-col-12 p-md-8">
                                <div className="p-grid  p-fluid" style={{ marginBottom: "10px" }}>
                                    <div className="p-col-12 p-md-6">
                                        <label>เลขที่สัญญา</label>
                                        <div className="p-inputgroup">
                                            <InputText
                                                id="contractNo"
                                                placeholder="เลขที่สัญญา"
                                                type="text"
                                                value={data.contractNo}
                                                onChange={(e) => onInputTextChange(e, "contractNo")}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-grid p-fluid" style={{ marginBottom: "10px" }}>
                                    <div className="p-col-12 p-md-6">
                                        <label>สถานะงานสั่งการเฉพาะอย่าง</label>
                                        <div className="p-inputgroup">
                                            <Dropdown id="orderStatus"
                                                value={data.orderStatus}
                                                onChange={(e) => onInputTextChange(e, "orderStatus")}
                                                options={orderStatusList}
                                                optionLabel="statusDesc"
                                                optionValue="statusCode"
                                                placeholder="เลือก สถานะงานสั่งการเฉพาะอย่าง" ></Dropdown>
                                        </div>
                                    </div>
                                    <div className="p-col-12 p-md-6">
                                        <label>ผู้สั่งงาน</label>
                                        <div className="p-inputgroup">
                                            <InputText
                                                id="supervisor"
                                                placeholder="ผู้สั่งงาน"
                                                type="text"
                                                value={data.supervisor}
                                                onChange={(e) => onInputTextChange(e, "supervisor")}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-grid p-fluid" style={{ marginBottom: "10px" }}>

                                    <div className="p-col-12 p-md-6">

                                        <label>วันที่จาก</label>
                                        <div className="p-inputgroup" >
                                            <Calendars maxLength="10"
                                                key ="orderDateBegin"
                                                id ="orderDateBegin"
                                                placeholder="วันที่จาก"
                                                value={new Date(data.orderDateBegin)}
                                                onChange={(e) => onInputTextChange(e, "orderDateBegin")}
                                                // minDate={new Date(formObject.announce_start_date)}
                                                // onChange={(e) => setformObject({ ...formObject, announce_finish_date: e.target.value })}
                                            />
                                        </div>
                                    </div>
                                    <div className="p-col-12 p-md-6">
                                        <label>ถึงวันที่</label>
                                        <div className="p-inputgroup">
                                            <Calendars maxLength="10"
                                                key ="orderDateEnd"
                                                id = "orderDateEnd"
                                                placeholder="ถึงวันที่"
                                                value={new Date(data.orderDateEnd)}
                                                onChange={(e) => onInputTextChange(e, "orderDateEnd")}
                                                // minDate={new Date(formObject.announce_start_date)}
                                                // onChange={(e) => setformObject({ ...formObject, announce_finish_date: e.target.value })}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="p-grid p-fluid" style={{ marginBottom: "10px" }}>
                                    <div className="p-col-12 p-md-12">
                                        <label>คำค้นหา</label>
                                        <div className="p-inputgroup">
                                            <InputText placeholder="คำค้นหา"
                                                id="searchWord" type="text"
                                                value={data.searchWord}
                                                onChange={(e) => onInputTextChange(e, "searchWord")}
                                            />
                                        </div>
                                    </div>
                                </div>



                                <div style={{ height: "20px" }} />
                                <div className="p-grid" style={{ textAlign: "center" }}>
                                    <div className="p-col-12">
                                        <Button
                                            className="p-button"
                                            icon="pi pi-search"
                                            label="ค้นหา"
                                            style={{ width: 170, marginTop: "10px" }}
                                            onClick={() => onSearch()}
                                        />
                                        <Button
                                            className="p-button-secondary p-button"
                                            icon="pi pi-arrow-left"
                                            label="กลับหน้าจอหลัก"
                                            // style={{ marginLeft: '5px' }}
                                            style={{ width: 170, marginLeft: "5px", marginTop: "10px" }}
                                            onClick={() => { history.push('/107') }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-2"></div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
